module.exports = __webpack_public_path__ + "static/media/icon.3926f9ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icon.svg
// module id = 285
// module chunks = 0